<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
        <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.right_menu.language }}</div>
        </div>
        <div class="overflow-y-auto h-screen locale-content-height">
            <div class="mx-4">
                <ul tabindex="0" class="menu p-2">
                    <li v-for="locale in locales" :key="'localeKey-' + locale">
                        <a :href="currentMapLink + '/' + locale" class="flex">
                            <div class="w-18">
                                <div class="btn-xs btn font-mono font-bold tracking-widest w-14 p-0 opacity-60 notranslate">{{ locale }}</div>
                            </div>
                            <div class="notranslate">
                            {{ trans.locales[locale] }}
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['displayLink', 'trans', 'currentMapLink'],
    props: {
        locales: {
            type: Array,
            default: []
        }
    }
};
</script>

<style>
.locale-content-height{
    padding-bottom: 10rem;
}
@media screen and (max-width:639px) {
    .locale-content-height{
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>